import RegisterSuccessPage from './register-success-page';

export default RegisterSuccessPage;
